/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Changelog_Selectfield2Inputs */

const id_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih bidang`)
};

const ms_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih medan`)
};

const da_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg et felt`)
};

const de_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feld auswählen`)
};

const en_us2_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a field`)
};

const es_es2_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un campo`)
};

const es_mx2_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un campo`)
};

const fil_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pumili ng field`)
};

const fr_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner un champ`)
};

const it_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un campo`)
};

const hu_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Válassz mezőt`)
};

const nl_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer een veld`)
};

const no_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velg et felt`)
};

const pl_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz pole`)
};

const pt_br2_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um campo`)
};

const pt_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar um campo`)
};

const ro_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectează un câmp`)
};

const fi_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse kenttä`)
};

const sv_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj ett fält`)
};

const vi_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn một trường`)
};

const tr_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir alan seçin`)
};

const cs_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte pole`)
};

const bg_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изберете поле`)
};

const ru_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите поле`)
};

const uk_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виберіть поле`)
};

const ar_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر حقلاً`)
};

const hi_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक फ़ील्ड चुनें`)
};

const th_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกฟิลด์`)
};

const ja_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィールドを選択`)
};

const zh_cn2_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一个字段`)
};

const zh_hant1_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選擇一個欄位`)
};

const ko_offerdetail_changelog_selectfield2 = /** @type {(inputs: Offerdetail_Changelog_Selectfield2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`필드 선택`)
};

/**
* | output |
* | --- |
* | "Select a field" |
*
* @param {Offerdetail_Changelog_Selectfield2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_changelog_selectfield2 = /** @type {((inputs?: Offerdetail_Changelog_Selectfield2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Changelog_Selectfield2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_changelog_selectfield2(inputs)
	if (locale === "ms") return ms_offerdetail_changelog_selectfield2(inputs)
	if (locale === "da") return da_offerdetail_changelog_selectfield2(inputs)
	if (locale === "de") return de_offerdetail_changelog_selectfield2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_changelog_selectfield2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_changelog_selectfield2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_changelog_selectfield2(inputs)
	if (locale === "fil") return fil_offerdetail_changelog_selectfield2(inputs)
	if (locale === "fr") return fr_offerdetail_changelog_selectfield2(inputs)
	if (locale === "it") return it_offerdetail_changelog_selectfield2(inputs)
	if (locale === "hu") return hu_offerdetail_changelog_selectfield2(inputs)
	if (locale === "nl") return nl_offerdetail_changelog_selectfield2(inputs)
	if (locale === "no") return no_offerdetail_changelog_selectfield2(inputs)
	if (locale === "pl") return pl_offerdetail_changelog_selectfield2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_changelog_selectfield2(inputs)
	if (locale === "pt") return pt_offerdetail_changelog_selectfield2(inputs)
	if (locale === "ro") return ro_offerdetail_changelog_selectfield2(inputs)
	if (locale === "fi") return fi_offerdetail_changelog_selectfield2(inputs)
	if (locale === "sv") return sv_offerdetail_changelog_selectfield2(inputs)
	if (locale === "vi") return vi_offerdetail_changelog_selectfield2(inputs)
	if (locale === "tr") return tr_offerdetail_changelog_selectfield2(inputs)
	if (locale === "cs") return cs_offerdetail_changelog_selectfield2(inputs)
	if (locale === "bg") return bg_offerdetail_changelog_selectfield2(inputs)
	if (locale === "ru") return ru_offerdetail_changelog_selectfield2(inputs)
	if (locale === "uk") return uk_offerdetail_changelog_selectfield2(inputs)
	if (locale === "ar") return ar_offerdetail_changelog_selectfield2(inputs)
	if (locale === "hi") return hi_offerdetail_changelog_selectfield2(inputs)
	if (locale === "th") return th_offerdetail_changelog_selectfield2(inputs)
	if (locale === "ja") return ja_offerdetail_changelog_selectfield2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_changelog_selectfield2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_changelog_selectfield2(inputs)
	return ko_offerdetail_changelog_selectfield2(inputs)
});
export { offerdetail_changelog_selectfield2 as "offerDetail.changelog.selectField" }